<div class="dialog-container">

  <div>
    <form [formGroup]="filterForm" (keydown.enter)="onApply()">
      <div>
        <mat-form-field appearance="outline" class="slim-width">
          <!-- <mat-label>Filters</mat-label> -->
          <mat-select placeholder="Select Filter" formControlName="filter">

            <mat-option class="fw-light" value="Status">Status</mat-option>
            <mat-option class="fw-light" value="Source">Source</mat-option>
            <mat-option class="fw-light" value="Due Date">Due Date</mat-option>
            <mat-option class="fw-light" value="RAG">Severity</mat-option>
            <mat-option class="fw-light" value="Organization">Organization</mat-option>

          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="filterForm.get('filter')?.value === 'Due Date'">
        <mat-form-field appearance="outline" class="slim-width">
          <input matInput formControlName="search" [matDatepicker]="picker" placeholder="Select Date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div *ngIf="filterForm.get('filter')?.value === 'RAG'" class="checkbox-group">
        <mat-checkbox [formControl]="Red"><span class="red">Red</span></mat-checkbox>
        <mat-checkbox [formControl]="Grey"><span class="gray">Grey</span></mat-checkbox>
        <mat-checkbox [formControl]="Amber"><span class="amber">Amber</span></mat-checkbox>
        <mat-checkbox [formControl]="Green"><span class="green">Green</span> </mat-checkbox>
      </div>

         <div *ngIf="filterForm.get('filter')?.value === 'Status'">
        <mat-form-field appearance="outline" class="slim-width">
          <mat-select placeholder="Select Status" formControlName="search">
            <mat-option [value]="Status.Completed">Completed Approved</mat-option>
            <mat-option [value]="Status.Pending">Pending Completion</mat-option>
            <mat-option [value]="Status.InReview">In Review</mat-option>

          </mat-select>
        </mat-form-field>
      </div>

        <div *ngIf="filterForm.get('filter')?.value === 'Source'">
        <mat-form-field appearance="outline" class="slim-width">
          <mat-select placeholder="Select Source" formControlName="search">
            <mat-option [value]="Source.RegEd">RegEd</mat-option>
            <mat-option [value]="Source.Starcomp">Star Compliance</mat-option>            
            <!-- <mat-option [value]="Source.FINRA">FINRA</mat-option> -->

          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filterForm.get('filter')?.value === 'Organization'">
        <mat-form-field appearance="outline" class="slim-width">
                    <input matInput formControlName="search" placeholder="Search">
                </mat-form-field>
      </div>

      <div class="button-container">
        <button mat-stroked-button color="warn" type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" type="button" (click)="onApply()">Apply</button>
      </div>
    </form>
  </div>
</div>